import { TranslationFunctions } from "~/i18n/i18n-types";

const getLocalizedLanguage = (LL: TranslationFunctions) => (locale: string) => {
	switch (locale) {
		case "auto":
			return LL.CREATE_ROOM_FORM.AUTO_DETECT();
		case "en-US":
			return LL.CREATE_ROOM_FORM.ENGLISH_US();
		case "ar-SA":
			return LL.CREATE_ROOM_FORM.ARABIC_KSA();
		case "es-CR":
			return LL.CREATE_ROOM_FORM.SPANISH_CR();
		case "ca-ES":
			return LL.CREATE_ROOM_FORM.CATALAN_ES();
		case "pt-PT":
			return LL.CREATE_ROOM_FORM.PORTUGUESE_PT();
		case "pt-BR":
			return LL.CREATE_ROOM_FORM.PORTUGUESE_BR();
		case "et-EE":
			return LL.CREATE_ROOM_FORM.ESTONIAN_EE();
		case "ru-RU":
			return LL.CREATE_ROOM_FORM.RUSSIAN_RU();
		case "mt-MT":
			return LL.CREATE_ROOM_FORM.MALTESE_MT();
		case "fil-PH":
			return LL.CREATE_ROOM_FORM.FILIPINO_PH();
		default:
			return undefined;
	}
};

export default getLocalizedLanguage;
